
<!-- Список атрибутов -->

<template>

	<b-form-group :state="state" label="Атрибут" label-for="input" invalid-feedback="Необходимо выбрать атрибут">

		<!-- appendToBody пока нет, т.к. обычные модалки их не поддерживают - z-index слишком мал -->
		<v-select :clearable="false" id="input" :value="value" :reduce="obj => obj.key" label="name" :options="attrs" v-on:input="handle_input" clearSearchOnSelect required :appendToBody="new_modal"/>

	</b-form-group>

</template>

<script>

import api from "../../api"

export default
{
	props :
	{
		value : String,
		new_modal : Boolean,
		is_all_attrs_editable : { type : Boolean, default : () => true },
		editable_attr_keys : { type : Array, default : () => [ "attrs.cost", "attrs.UPKS" ] },
		without_system : Boolean,
		without_bad : Boolean,
		service : String,
	},

	data()
	{
		return {

			state : null,
			attrs : [],

		}
	},

	beforeMount()
	{
		var params = {}

		return api.call(this, "cadastral_attrs", "get_many", params,
			response =>
			{
				var attrs = response.data

				if(! this.is_all_attrs_editable)
					attrs = attrs.filter(attr => this.editable_attr_keys.includes(attr.key))

				if(this.without_system)
					attrs = attrs.filter(attr => attr.status != "system")

				if(this.without_bad)
					attrs = attrs.filter(attr => attr.key != "attrs.bad")

				if(this.service)
				{
					if(this.service == "cadastral_objects")
						attrs = attrs.filter(attr => attr.show.cadastral_objects)
					else if(this.service == "cadastral_analogues")
						attrs = attrs.filter(attr => attr.show.analogues)
					else // cadastral_coinvest
						attrs = attrs.filter(attr => attr.show.coinvest)
				}

				this.attrs = api.sort_objects_array_by_key(attrs, "name")
			})
	},

	methods :
	{
		handle_input(event)
		{
			this.$emit("input", event)
		},

		check()
		{
			this.state = this.value != null && this.value != "" && !!this.value

			return this.state
		}
	}
}

</script>

